export class Office {
  id: number;
  city: string;
  address: string;
  phone: string;
  timeZone: string;
  zkTecoHost: string;
  zkTecoPort: number;

  public constructor(init?: Partial<Office>) {
    Object.assign(this, init);
  }
}
